import React, { FC } from 'react'
import './index.scss'

import point6_6Img from '@img/mkt/point/points6_6.png'
import point6_5Img from '@img/mkt/point/points6_5.png'
import point6_4Img from '@img/mkt/point/points6_4.png'
import point6_3Img from '@img/mkt/point/points6_3.png'
import point6_2Img from '@img/mkt/point/points6_2.png'
import point6_1Img from '@img/mkt/point/points6_1.png'
import point8_1Img from '@img/mkt/point/points8_1.png'
import point8_2Img from '@img/mkt/point/points8_2.png'
import point8_3Img from '@img/mkt/point/points8_3.png'
import point8_4Img from '@img/mkt/point/points8_4.png'
import point8_5Img from '@img/mkt/point/points8_5.png'
import point8_6Img from '@img/mkt/point/points8_6.png'
import point8_7Img from '@img/mkt/point/points8_7.png'
import point8_8Img from '@img/mkt/point/points8_8.png'
import point10_1Img from '@img/mkt/point/points10_1.png'
import point10_2Img from '@img/mkt/point/points10_2.png'
import point10_3Img from '@img/mkt/point/points10_3.png'
import point10_4Img from '@img/mkt/point/points10_4.png'
import point10_5Img from '@img/mkt/point/points10_5.png'
import point10_6Img from '@img/mkt/point/points10_6.png'
import point10_7Img from '@img/mkt/point/points10_7.png'
import point10_8Img from '@img/mkt/point/points10_8.png'
import point10_9Img from '@img/mkt/point/points10_9.png'
import point10_10Img from '@img/mkt/point/points10_10.png'
import squareBgImg from '@img/mkt/point/squareBg.png'

interface IProps {
  data: any;
}

const PointTemp: FC<IProps> = (props: IProps) => {
  const { data } = props
  const irregularBg = () => {
    const unPoint = data.points >= data.participateNum ? 0 : data.participateNum - data.points
    if (unPoint > 0) {
      const unPointImg = {
        6: [point6_1Img, point6_2Img, point6_3Img, point6_4Img, point6_5Img, point6_6Img],
        8: [point8_1Img, point8_2Img, point8_3Img, point8_4Img, point8_5Img, point8_6Img, point8_7Img, point8_8Img],
        10: [point10_1Img, point10_2Img, point10_3Img, point10_4Img, point10_5Img, point10_6Img, point10_7Img, point10_8Img, point10_9Img, point10_10Img]
      }
      return unPointImg[data.participateNum][unPoint - 1]
    } else {
      return ''
    }
  }
  return (
    <div className='point-card-template' style={data.playbill && data.displayStyle.tempType !== 'default' ? { backgroundImage: `url(${data.playbill})` } : {}}>
      {
        data.displayStyle.tempType === 'square' && data.displayStyle.squareStyle === 'rectangle' &&
          <div className='rectangle-block'>
            {
              [...Array(data.participateNum)].map((item, index: number) => (
                <div key={index} className={`rectangle-item${data.points >= index + 1 ? ' rectangle-item-ed' : ''}`} style={{ height: `${100 / data.participateNum}%`, backgroundImage: `url(${squareBgImg})`, backgroundPosition: `0% ${100 / (data.participateNum - 1) * index}%` }}>
                  {data.points < index + 1 && <img style={{ width: `${30 * (data.displayStyle.iconScale || 1)}px`, height: `${32 * (data.displayStyle.iconScale || 1)}px` }} src={data.iconDisable} alt='' />}
                </div>
              ))
            }
          </div>
      }
      {
        data.displayStyle.tempType === 'square' && data.displayStyle.squareStyle === 'square' &&
          <div className='square-block'>
            {
              [...Array(data.participateNum)].map((item, index: number) => (
                <div key={index} className={`square-item${data.participateNum % 2 === 0 ? '' : ' square-item-single'}${data.points >= index + 1 ? ' square-item-ed' : ''}`} style={{ height: `${100 / (Math.ceil(data.participateNum / 2))}%`, backgroundImage: `url(${squareBgImg})`, backgroundPosition: `${index % 2 === 0 ? 0 : 100}% ${100 / (Math.ceil(data.participateNum / 2) - 1) * Math.floor(index / 2)}%` }}>
                  {data.points < index + 1 && <img style={{ width: `${30 * (data.displayStyle.iconScale || 1)}px`, height: `${32 * (data.displayStyle.iconScale || 1)}px` }} src={data.iconDisable} alt='' />}
                </div>
              ))
            }
          </div>
      }
      {
        data.displayStyle.tempType === 'square' && data.displayStyle.squareStyle === 'irregular' &&
          <div className='irregular-block' style={{ backgroundImage: `url(${irregularBg()})` }}>
            {
              [...Array(data.participateNum)].map((item, index: number) => (
                <div key={index} className={`irregular-item${data.points >= index + 1 ? ' irregular-opacity' : ''}`} style={{ height: `${100 / (Math.ceil(data.participateNum / 2))}%` }}>
                  {data.points < index + 1 && <img style={{ width: `${30 * (data.displayStyle.iconScale || 1)}px`, height: `${32 * (data.displayStyle.iconScale || 1)}px` }} src={data.iconDisable} alt='' />}
                </div>
              ))
            }
          </div>
          // <div className='irregular-block2'>
          //   {
          //     [...Array(data.participateNum)].map((item, index: number) => (
          //       <>
          //         {
          //           index % 2 === 0
          //             ? (
          //               <div key={index} className={`irregular-item irregular-item-left${data.points >= index + 1 ? ' irregular-opacity' : ''}`} style={{ height: `${100 / (Math.ceil(data.participateNum / 2))}%` }}>
          //                 {index === 2 && <div className='irregular-item-circle circle-top'></div>}
          //                 <div className='irregular-item-circle circle-right'></div>
          //                 {![0, [...Array(data.participateNum)].length - 2].includes(index) && <div className='irregular-item-circle circle-bottom'></div>}
          //                 {
          //                   ![0].includes(index) &&
          //                     <div className='irregular-item-cross'>
          //                       <div className='border-line'></div>
          //                       <div className={`border-circle${index === 2 ? ' circle-convex' : ''}`}></div>
          //                       <div className='border-line'></div>
          //                     </div>
          //                 }
          //                 <img style={{ width: `${32 * (data.displayStyle.iconScale || 1)}px`, height: `${32 * (data.displayStyle.iconScale || 1)}px`, zIndex: 10 }} src={data.iconDisable} alt='' />
          //               </div>
          //             ) : (
          //               <div key={index} className={`irregular-item irregular-item-right${data.points >= index + 1 ? ' irregular-opacity' : ''}`} style={{ height: `${100 / (Math.ceil(data.participateNum / 2))}%` }}>
          //                 {[...Array(data.participateNum)].length - 1 !== index && <div className='irregular-item-circle circle-bottom'></div>}
          //                 <div className='irregular-item-border'>
          //                   <div className='border-line'></div>
          //                   <div className={`border-circle${index === 2 ? ' circle-convex' : ''}`}></div>
          //                   <div className='border-line'></div>
          //                 </div>
          //                 {
          //                   ![1].includes(index) &&
          //                     <div className='irregular-item-cross'>
          //                       <div className='border-line'></div>
          //                       <div className='border-circle'></div>
          //                       <div className='border-line'></div>
          //                     </div>
          //                 }
          //                 <img style={{ width: `${32 * (data.displayStyle.iconScale || 1)}px`, height: `${32 * (data.displayStyle.iconScale || 1)}px`, zIndex: 10 }} src={data.iconDisable} alt='' />
          //               </div>
          //             )
          //         }
          //       </>
          //     ))
          //   }
          // </div>
      }
      {
        data.displayStyle.tempType === 'custom' && data.displayStyle?.customStyle &&
          <div className='custom-block'>
            {
              data.displayStyle.customStyle.map((item, index: number) => (
                <div
                  key={index} className='custom-item'
                  style={{ top: `${item.top}px`, left: `${item.left}px` }}
                >
                  <div
                    className='custom-item-img'
                    style={{ width: `${32 * (data.displayStyle.iconScale || 1)}px`, height: `${32 * (data.displayStyle.iconScale || 1)}px`, backgroundImage: `url(${data.points < index + 1 ? data.iconDisable : data.iconEnable})` }}
                  >
                  </div>
                </div>
              ))
            }
          </div>
      }
    </div>
  )
}
export default PointTemp
